<template>
    <div class="entire_client_app__sidebar">
        <div :class="{'--sidebar_toggled_expd_logo_container': $store.state.SidebarToggle.sidebar_toggled}" class="logo_container">
            <div :class="{'--full_width': $store.state.SidebarToggle.sidebar_toggled}"  class="menu_toggle" @click="$store.commit('SidebarToggle/togglesidebar')">
                <svg id="menu" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28">
                    <path id="Path_1" data-name="Path 1" d="M0,0H28V28H0Z" fill="none"/>
                    <path id="Path_2" data-name="Path 2" d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z" transform="translate(0)" fill="#1d2329"/>
                </svg>
            </div>
            <div :class="{'--sidebar_toggled_hide_logo': $store.state.SidebarToggle.sidebar_toggled}" class="logo">
                <img src="../assets/logo.png" alt="logo">
            </div>
            <div :class="{'--full_width': $store.state.SidebarToggle.sidebar_toggled}"  class="settings">
                <router-link to="/profile"><svg id="settings" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28">
                    <path id="Path_3" data-name="Path 3" d="M0,0H28V28H0Z" fill="none"/>
                    <path id="Path_4" data-name="Path 4" d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z" transform="translate(0 0)" fill="#1d2329"/>
                </svg></router-link>
            </div>
        </div>
        <div :class="{'--sidebar_toggled_expd_user_account_container': $store.state.SidebarToggle.sidebar_toggled}" class="user_account_container">
            <div :class="{'--sidebar_toggled_hide_user_avatar': $store.state.SidebarToggle.sidebar_toggled}" class="user_avatar">
                <svg id="Component_108_1" data-name="Component 108 – 1" xmlns="http://www.w3.org/2000/svg" width="169.706" height="169.706" viewBox="0 0 169.706 169.706">
                    <g id="tickets" transform="translate(156.472 121.998) rotate(163)" fill="none" stroke="#487fff" stroke-linecap="round" stroke-width="4" stroke-dasharray="29 8">
                        <circle cx="57.5" cy="57.5" r="57.5" stroke="none"/>
                        <circle cx="57.5" cy="57.5" r="55.5" fill="none"/>
                    </g>
                    <g id="tickets-2" data-name="tickets" transform="translate(169.706 84.853) rotate(135)" fill="none" stroke="#eaedf4" stroke-linecap="round" stroke-width="8" stroke-dasharray="100 965">
                        <circle cx="60" cy="60" r="60" stroke="none"/>
                        <circle cx="60" cy="60" r="56" fill="none"/>
                    </g>
                    <circle id="Ellipse_5" data-name="Ellipse 5" cx="5" cy="5" r="5" transform="translate(35.606 112.567)" fill="#59d269"/>
                </svg>
                <div class="image">
                    <img v-if="$store.state.UserDetails.user.photo ==''" src="../assets/default.png" alt="avatar">
                    <img v-else: :src="$store.state.UserDetails.user.photo" alt="avatar">
                </div>
            </div>
            <div :class="{'--sidebar_toggled_hide_user_details': $store.state.SidebarToggle.sidebar_toggled}" class="user_details">
                <h2>{{ $store.state.UserDetails.user.firstname }} {{ $store.state.UserDetails.user.lastname}}</h2>
                <div class="promo_level_container">
                    <p>{{ levelOfPromotion }}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5">
                        <g id="level_separator" data-name="level separator" fill="#1d2329" stroke="#1d2329" stroke-width="1">
                            <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
                            <circle cx="2.5" cy="2.5" r="2" fill="none"/>
                        </g>
                    </svg>
                    <p class="level_grades">{{ levelsOfProGrade }}</p>
                </div>
            </div>
        </div>
        <div class="navigation_container">
            <div class="navigation_links">

                <router-link to="/dashboard">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="dashboard-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_13" data-name="Path 13" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_14" data-name="Path 14" d="M15.222,25V12.778H25V25ZM3,15.222V3h9.778V15.222Zm7.333-2.444V5.444H5.444v7.333ZM3,25V17.667h9.778V25Zm2.444-2.444h4.889V20.111H5.444Zm12.222,0h4.889V15.222H17.667ZM15.222,3H25v7.333H15.222Zm2.444,2.444V7.889h4.889V5.444Z" transform="translate(0 0)" fill="#1D2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Dashboard</div>
                    </div>
                </router-link>
                
                <router-link to="/myTickets/bus">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="card" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_15" data-name="Path 15" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_16" data-name="Path 16" d="M3.2,3H24.8A1.211,1.211,0,0,1,26,4.222V23.778A1.211,1.211,0,0,1,24.8,25H3.2A1.211,1.211,0,0,1,2,23.778V4.222A1.211,1.211,0,0,1,3.2,3Zm20.4,9.778H4.4v9.778H23.6Zm0-2.444V5.444H4.4v4.889Zm-7.2,7.333h4.8v2.444H16.4Z" transform="translate(0 0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">My tickets</div>
                    </div>
                </router-link>

                <router-link to="/routes">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="route-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_17" data-name="Path 17" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_18" data-name="Path 18" d="M4.571,15V8.5c0-2.485,2.4-4.5,5.357-4.5s5.357,2.015,5.357,4.5v7A2.769,2.769,0,0,0,18.262,18a2.769,2.769,0,0,0,2.976-2.5V8.83a2.983,2.983,0,0,1-2.331-3.337A3.454,3.454,0,0,1,22.428,3,3.454,3.454,0,0,1,25.95,5.493,2.983,2.983,0,0,1,23.619,8.83V15.5c0,2.485-2.4,4.5-5.357,4.5S12.9,17.985,12.9,15.5v-7A2.769,2.769,0,0,0,9.928,6,2.769,2.769,0,0,0,6.952,8.5V15h3.571L5.762,20,1,15ZM22.428,7a1.108,1.108,0,0,0,1.19-1,1.209,1.209,0,0,0-2.381,0A1.108,1.108,0,0,0,22.428,7Z" transform="translate(0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Available routes</div>
                    </div>
                </router-link>
 
                <!-- <router-link to="/geoMap">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="road-map-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_19" data-name="Path 19" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_20" data-name="Path 20" d="M4.4,7.123V22.389l6.078-2.583,7.2,3.571,5.922-2.52V5.592l1.564-.664a.6.6,0,0,1,.567.05.594.594,0,0,1,.27.5V22.429L17.6,26l-7.2-3.571L2.836,25.644a.6.6,0,0,1-.567-.05A.594.594,0,0,1,2,25.1V8.143Zm14.692,6.071L14,18.244l-5.092-5.05a7.1,7.1,0,0,1,0-10.1,7.241,7.241,0,0,1,10.182,0,7.1,7.1,0,0,1,0,10.1ZM14,14.877l3.394-3.368a4.735,4.735,0,0,0,0-6.735,4.827,4.827,0,0,0-6.789,0,4.735,4.735,0,0,0,0,6.735Z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Geo map</div>
                    </div>
                </router-link> -->

                <router-link to="/contactUs">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="customer-service-2-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_23" data-name="Path 23" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_24" data-name="Path 24" d="M23.381,9.273h1.255A2.364,2.364,0,0,1,27,11.636v4.727a2.364,2.364,0,0,1-2.364,2.364H23.381A9.456,9.456,0,0,1,14,27V24.636a7.091,7.091,0,0,0,7.091-7.091V10.454a7.091,7.091,0,1,0-14.182,0v8.273H3.364A2.364,2.364,0,0,1,1,16.364V11.636A2.364,2.364,0,0,1,3.364,9.273H4.619a9.456,9.456,0,0,1,18.763,0ZM3.364,11.636v4.727H4.545V11.636Zm20.091,0v4.727h1.182V11.636ZM8.989,18.473l1.253-2a7.1,7.1,0,0,0,7.516,0l1.253,2a9.461,9.461,0,0,1-10.022,0Z" transform="translate(0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Contact Us</div>
                    </div>
                </router-link>
                <router-link to="/provider" v-if="$store.state.UserDetails.user.role == 'provider'">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="customer-service-2-line" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                                <path id="Path_23" data-name="Path 23"  fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M15 3h6v5h-2V5h-4V3zM9 3v2H5v3H3V3h6zm6 18v-2h4v-3h2v5h-6zm-6 0H3v-5h2v3h4v2zM3 11h18v2H3v-2z" transform="translate(0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Provider panel</div>
                    </div>
                </router-link>
                <router-link to="/shaloi" v-if="$store.state.UserDetails.user.role == 'shaloi'">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243-1.414-1.414L8.586 17zM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1zm1 2v7h12V5H6z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Shaloi panel</div>
                    </div>
                </router-link>
                <router-link to="/admin" v-if="$store.state.UserDetails.user.role == 'admin'">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243-1.414-1.414L8.586 17zM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1zm1 2v7h12V5H6z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Admin panel</div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="favourite_companies">
            <div class="favourite_companies__title">
                <div class="title_statement" :class="{'--sidebar_toggled_hide_fav_title_statement': $store.state.SidebarToggle.sidebar_toggled}">
                    <h4 :class="{'--sidebar_toggled_hide_fav_title': $store.state.SidebarToggle.sidebar_toggled}">
                        Favourite <span :class="{'--sidebar_toggled_hide_fav_nm': $store.state.SidebarToggle.sidebar_toggled}">companies</span>
                    </h4>
                </div>
                <div class="add_favourite_company" :class="{'--sidebar_toggled_hide_add_comp': $store.state.SidebarToggle.sidebar_toggled}">
                    <svg @click="$store.commit('SidebarToggle/change_adding_fav_status')" id="add-circle-fill" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                        <path id="Path_25" data-name="Path 25" d="M0,0H28V28H0Z" fill="none"/>
                        <path id="Path_26" data-name="Path 26" d="M14,26A12,12,0,1,1,26,14,12,12,0,0,1,14,26ZM12.8,12.8H8v2.4h4.8V20h2.4V15.2H20V12.8H15.2V8H12.8Z" fill="#487fff"/>
                    </svg>
                </div>
            </div>
            <div class="favourite_companies__container">
                <p class="no_fav" v-if="$store.state.SidebarToggle.my_favourite_companies.length <= 0">No favourite companies</p>
                <div class="favourite_company_content" v-for="(compy, index) in $store.state.SidebarToggle.my_favourite_companies" :key="index" :class="{'overthedel': deletingElement}" @mouseover="deleteHandle(index)" @mouseleave="deleteReseter()">
                    <div :class="{'--sidebar_toggled_full_company_logo': $store.state.SidebarToggle.sidebar_toggled}" class="company_logo">
                        <img @click="$store.commit('SidebarToggle/setCurrentFavourite', compy)" src="../assets/fav_bus.png" alt="logo">
                    </div>
                    <div :class="{'--sidebar_toggled_hide_company_name': $store.state.SidebarToggle.sidebar_toggled}" class="company_name">
                        <p @click="$store.commit('SidebarToggle/setCurrentFavourite', compy)" :class="{'active': $store.state.SidebarToggle.current_favourite == compy}">{{ compy }}</p>
                    </div>
                    <div class="del" v-if="deleteElement == index">
                        <svg @click="$store.commit('SidebarToggle/removeFavourite', index)" aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-trash">
                            <path fill-rule="evenodd" fill="rgba(0,0,0,0.6)" d="M6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zm4.5 0V3h2.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM4.496 6.675a.75.75 0 10-1.492.15l.66 6.6A1.75 1.75 0 005.405 15h5.19c.9 0 1.652-.681 1.741-1.576l.66-6.6a.75.75 0 00-1.492-.149l-.66 6.6a.25.25 0 01-.249.225h-5.19a.25.25 0 01-.249-.225l-.66-6.6z"></path>
                        </svg>
                    </div>
                </div>

            </div>
        </div>   

        <div :class="{'--sidebar_toggled_log_btn_full': $store.state.SidebarToggle.sidebar_toggled}" class="logout_btn">
            <button @click="logout">
                <span v-if="!$store.state.SidebarToggle.sidebar_toggled">Logout</span> 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.985 9.985 0 0 1 8 4h-2.71a8 8 0 1 0 .001 12h2.71A9.985 9.985 0 0 1 12 22zm7-6v-3h-8v-2h8V8l5 4-5 4z" fill="#ffffff"/></svg>
            </button>
        </div>     
    </div>
</template>

<script>
    import router from '../router/index'
    // import { mapState } from 'vuex'

    export default {
        name: "Sidebar",

        data() {
            return { 
                currentuser: new String(),
                levelOfPromotion: "Intermediate",
                levelsOfProGrade: "2 levels",
                companies: [
                    "Volcano Ltd",
                    "Matunda Express",
                    "Stella Yigitarama"
                ],
                deleteElement: '',
                deletingElement: false
            }
        },
        
        methods: {
            logout() {
                localStorage.removeItem("jwt");
                router.push("/")
            },
            deleteHandle(data) {
                this.deleteElement = data;
                this.deletingElement = true;
            },
            deleteReseter() {
                this.deleteElement = '';
                this.deletingElement = false;
            },
            checkIfLoadingIsDone() {
                if (this.$store.state.UserDetails.user.firstname != undefined && this.$store.state.UserDetails.user.firstname != null && this.$store.state.UserDetails.user != [] ) {
                    this.$store.commit('SidebarToggle/updateLoadingNumber');
                } else {
                    let checkInter = setInterval(()=> {
                        if (this.$store.state.UserDetails.user.firstname != undefined && this.$store.state.UserDetails.user.firstname != null && this.$store.state.UserDetails.user != [] ) {
                            this.$store.commit('SidebarToggle/updateLoadingNumber');
                            clearInterval(checkInter);
                        } 
                    }, 3000)
                }
            }
        },

        // created() {
        //     var userDataToDisplay = this.$store.state.UserDetails.user.data
        //     Object.assign(this.user, userDataToDisplay)       
        // },

        computed: {
            user() {
                var userDataToDisplay = this.$store.state.UserDetails.user;
                return Object.assign(this.currentuser, userDataToDisplay);    
            },                
        },


        mounted() {
            // this.$store.dispatch.userData("getUser")
            this.$store.dispatch('UserDetails/getUser')
            this.$store.commit('SidebarToggle/getAllCompanies')
            this.$store.commit('SidebarToggle/getMyFavouriteCompanies')
            this.checkIfLoadingIsDone();
        }
   }
</script>

<style lang="scss" scoped>

    .entire_client_app__sidebar {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        flex-direction: column;

        & .--sidebar_toggled_expd_logo_container {
            height: 11% !important;
        }

        & .logo_container {
            width: 100%;
            height: 8%;
            display: flex;
            flex-wrap: wrap;

            .menu_toggle {
                width: 22%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }

            .--full_width {
                width: 100% !important;
                height: 50% !important;
            }

            .--sidebar_toggled_hide_logo {
                display: none !important;
            }

            .logo {
                width: 56%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 80%;
                    margin-top: 0.2em;
                }
            }

            .settings {
                width: 22%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }

        & .--sidebar_toggled_expd_user_account_container {
            height: 10% !important;
        }

        & .user_account_container {
            height: 25%;
            width: 100%;

            .--sidebar_toggled_hide_user_avatar {
                height: 100% !important;

                & .image {
                    // width: 40% !important;
                    width: 2.3em !important;
                    height: 2.3em !important;
                }

                & svg {
                    width: 76% !important;
                    position: absolute;
                }
            }

            .user_avatar {
                height: 50%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;                
                position: relative;

                & svg {
                    width: 52%;
                    // width: 8em;
                    // height: 8em;
                    transform: rotate(265deg);
                    position: absolute;
                }

                & .image {
                    width: 4.3em;
                    height: 4.3em;
                    overflow: hidden;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: $routeShadows;

                    img {
                        width: auto;
                        max-width: 100%;
                        height: auto;
                        max-height: 100%;
                    }  
                } 
            }

            .--sidebar_toggled_hide_user_details {
                display: none !important;
            }

            .user_details {
                height: 50%;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                h2 {
                    color: $mainDark;
                    font-family:satoshi, $poppins;
                    font-size: 1.1em;
                }

                .promo_level_container {
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    p {
                        font-family:satoshi, $poppins;
                        font-size: 0.72em;
                        font-weight: 500;
                        color: $dimerDark;
                    }

                    svg {
                        margin: 0 0.5em;
                    }

                    .level_grades {
                        color: $mainRed !important;
                    }

                }
            }
        }

        & .navigation_container {
            background-color: $mainBlueLight;
            height: 30%;
            width: 100%;
            margin-top: -0.5em;
            display: flex;
            justify-content: center;
            align-items: center;

            .navigation_links {
                width: 95%;
                height: 100%;
                border-radius: 0.25em;

                .navigation_link_content {
                    width: 100%;
                    height: 20%;
                    border-radius: 0.22em;
                    display: flex;
                    align-items: center;

                    .--sidebar_toggled_hide_link_icon_full_width {
                        width: 100% !important;

                        svg {
                            width: 28% !important;
                        }

                    }

                    .link_icon {
                        width: 20%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        svg {
                            width: 45%;
                        }
                    }

                    .--sidebar_toggled_hide_link_name {
                        display: none !important;
                    }

                    .link_name {
                        width: 80%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        font-family:satoshi, $poppins;
                        font-size: 0.85em;
                        font-weight: 580;
                    }
                }
            }
        }

        & .favourite_companies {
            width: 100%;
            height: 22%;
            margin-top: 5%;

            .favourite_companies__title {
                width: 100%;
                height: 25%;
                display: flex;
                justify-content: center;
                align-items: center;

                .--sidebar_toggled_hide_fav_title_statement {
                    width: 100% !important;
                    justify-content: center !important;
                    padding: 0 !important;
                }

                .title_statement {
                    width: 82%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    padding-left: 0.8em;

                    .--sidebar_toggled_hide_fav_title {
                        font-size: 0.78em !important;
                    }

                    h4 {
                        font-family:satoshi, $poppins;
                        font-size: 0.85em;
                        color: $dimestDark;

                        .--sidebar_toggled_hide_fav_nm {
                            display: none !important;
                        }
                    }
                }

                .--sidebar_toggled_hide_add_comp {
                    display: none !important;
                }

                .add_favourite_company {
                    width: 18%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    svg {
                        width: 1.2em;
                        cursor: pointer;
                    }
                }
                
            }

            .favourite_companies__container {
                width: 100%;
                height: 75%;

                .no_fav {
                    font-size: 0.75em;
                    color: $mainDark;
                    opacity: 0.6;
                    text-align: center;
                    margin-top: 2em;
                }

                .overthedel {
                    .del {
                        display: flex !important;
                    }
                } 

                .favourite_company_content {
                    width: 100%;
                    height: 34%;
                    display: flex;
                    position: relative;

                    .--sidebar_toggled_full_company_logo {
                        width: 100% !important;
                    }

                    .company_logo {
                        height: 100%;
                        width: 20%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 50%;
                            cursor: pointer;
                        }
                    }

                    .del {
                        height: 100%;
                        width: 3em;
                        display: none;
                        justify-content: center;
                        align-items: center;
                        background: $mainDimBlue;
                        cursor: pointer;
                        position: absolute;
                        right: 0;
                        top: 0;
                        transition: all .5s ease;
                    }

                    .--sidebar_toggled_hide_company_name {
                        display: none !important;
                    }

                    .company_name {
                        width: 80%;
                        height: 100%;
                        display: flex;
                        align-items: center;

                        .active {
                            font-weight: 600;
                        }

                        p {
                            font-family:satoshi, $poppins;
                            font-size: 0.82em;
                            opacity: 0.85;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        & .--sidebar_toggled_log_btn_full {
            button {
                border: none;
                padding: 0.7em 2em;
                border-radius: 0.3em;
                display: flex;
                justify-content: center;
                align-items: center;

                svg {
                    margin-left: 0 !important;
                    margin: auto;
                }
            }
        }

        & .logout_btn {
            width: 100%;
            height: 15%;
            display: flex;
            justify-content: center;
            align-items: center;

            button {
                border: none;
                padding: 0.6em 2em;
                border-radius: 0.3em;
                font-family:satoshi, $poppins;
                font-size: 0.82em;
                color: $pureWhite;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                background-color: $mainBlue;

                svg {
                    margin-left: 0.8em;
                }
            }
        }

    }
</style>
